import { Injectable } from "@angular/core";

import { CommonState } from "../state";

import { AssessmentForm, CustomerAssessments } from "./customer-assessments.model";

/**
 * @deprecated [fabric-deprecated] - Use CustomerAssessmentService from app-account instead
 */
@Injectable({
	providedIn: "root",
})
export class CustomerAssessmentsSelector {
	/**
	 * @deprecated [fabric-deprecated] - Use AccountAppValue.GetAssessment instead
	 */
	getAssessment() {
		return (state: CommonState): AssessmentForm | undefined => state.customerAssessments.currentAssessment;
	}
	/**
	 * @deprecated [fabric-deprecated] - Use AccountAppValue.GetCustomerAssessments instead
	 */
	getCustomerAssessments() {
		return (state: CommonState): CustomerAssessments[] => state.customerAssessments.customerAssessments;
	}
}
